import router from './login.router'

export default {
  router,
}
